import mixpanel from 'mixpanel-browser';
window.mixpanel = mixpanel;

// posthog is NOT bundled here on purpose — it is loaded via the official CDN snippet
// in app/views/layouts/_posthog_snippet.html.erb. Bundling it through esbuild produced
// a build whose init() threw and silently disabled all capture. See CU-86ak9y0z4.
